import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import UnlinkDeviceModal from '../../pages/Modals/UnlinkDeviceModal';
import { UnlinkUserDevice } from '../../reduxToolkit/Providers/providersApi';
import ButtonAction from './ButtonAction';
import {MobileIcon} from './IconButtons';

const UnlinkDeviceBtn = ({ updated, userId }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [showModal, setShowModal] = useState(false);

    const unlinkDevice = () => {
        dispatch(UnlinkUserDevice(userId)).then(
            ({
                payload: {
                    data: { success },
                },
            }) => {
                if (success === true) {
                    updated();
                }
            },
        );
    };

    return (
        <>
            <ButtonAction
                id='btn_udb_unlink_device'
                name='unlink_device'
                className='btn-icon-delete'
                Icon={MobileIcon}
                splitName={false}
                onClick={()=>{
                    setShowModal(true);
                }}
            />

            <UnlinkDeviceModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onClickFn={() => unlinkDevice()}
                title_modal={t('unlink_device')}
                description={'unlink_confirmation_msg'}
                element_modal={t('employees')}
            />
        </>
    );
};

export default UnlinkDeviceBtn;
